<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>医生统计</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <PieChart id="doctor_fees_pie"
                          :params="{'clinic_id':this.clinic_id}"
                          height="300px"
                          width="100%"
                          path="doctor_fees_pie"></PieChart>
              </el-col>
              <el-col :span="12">
                <PieChart id="doctor_cfl_pie"
                          :params="{'clinic_id':this.clinic_id}"
                          height="300px"
                          width="100%"
                          path="doctor_cfl_pie"></PieChart>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>医生列表</span>
            </div>
            <el-row>
              <el-table
                  :data="clinic_doctor_list"
                  :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                  :row-class-name="tableRowClassName">
                <el-table-column prop="医生姓名" label="医生姓名"></el-table-column>
                <el-table-column label="联系电话">
                  <template slot-scope="scope">
                    <span class="date">
                      {{ isDemo ? "******" : scope.row.联系电话 }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="简介" label="简介"></el-table-column>
                <el-table-column prop="电子邮件" label="电子邮件"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button @click="show_skill(scope.row)" type="text" style="color: rgb(46, 205, 129);"
                               size="small">医生技能分析
                    </el-button>
                    <el-button @click="show_patient(scope.row)" type="text" style="color: rgb(46, 205, 129);"
                               size="small">医生接诊分析
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


    <el-dialog
      title="擅长疾病与用药习惯"
      :visible.sync="skillDialogTableVisible"
      width="75%"
      append-to-body
      custom-class="clinic-doctor-skill-dialog"
    >
      <div class="doctor-skill-dialog-body el-dialog-div">
        <el-row :gutter="20" class="doctor-skill-dialog-row">
          <el-col :span="12" :xs="24">
            <div class="doctor-skill-chart-cell">
              <PieChart
                id="doctor_skill_pie"
                :params="{'doctor_id':this.doctor_id}"
                height="400px"
                :key="doctor_id"
                width="100%"
                path="doctor_skill_pie"
              />
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <div class="doctor-skill-chart-cell">
              <PieChart
                id="doctor_drug_pie"
                :params="{'doctor_id':this.doctor_id}"
                height="400px"
                :key="doctor_id"
                width="100%"
                path="doctor_drug_pie"
              />
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog title="接诊病人统计" :visible.sync="patientDialogTableVisible" width="75%">
      <div class="el-dialog-div">
        <el-row :gutter="20" style="margin-left: 20px;margin-right: 20px;margin-top: 20px">
          <el-col :span="12">
            <PieChart id="doctor_patient_age_pie"
                      :params="{'doctor_id':this.doctor_id}"
                      height="400px"
                      :key="doctor_id"
                      width="100%"
                      path="doctor_patient_age_pie"></PieChart>
          </el-col>
          <el-col :span="12">
            <PieChart id="doctor_patient_gender_pie"
                      :params="{'doctor_id':this.doctor_id}"
                      height="400px"
                      :key="doctor_id"
                      width="100%"
                      path="doctor_patient_gender_pie"></PieChart>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PieChart from "@/views/charts/pie";
import {Role} from "@/role";

export default {
  name: "ClinicDoctorStat",
  components: {
    PieChart
  },
  data() {
    return {
      clinic_doctor_list: null,
      // clinic_id: '1650588070122270721',
      clinic_id: this.$route.query.clinic_id ? this.$route.query.clinic_id : (localStorage.getItem('clinic_id') ? localStorage.getItem('clinic_id') : '1650588070122270721'),
      doctor_id: this.$route.query.doctor_id ? this.$route.query.doctor_id : '-1',
      skillDialogTableVisible: false,
      patientDialogTableVisible: false,
    }
  },
  computed: {
    isDemo: function () {
      return this.$store.getters.user_role === Role.Demo
    },
  },
  mounted() {
    this.get_clinic_doctor_list();
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
    get_clinic_doctor_list() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_clinic_doctor_list?clinic_id="
          + this.clinic_id + "&doctor_id=" + this.doctor_id).then((res) => {
        console.log(res);
        this.clinic_doctor_list = res.data.data
      })
    },
    show_skill(row) {
      this.doctor_id = row.doctor_id
      this.skillDialogTableVisible = true
    },
    show_patient(row) {
      this.doctor_id = row.doctor_id
      this.patientDialogTableVisible = true
    }
  }
}
</script>

<style scoped>
.el-dialog-div {
  overflow: auto;
}

/* 「擅长疾病与用药习惯」弹窗内容区：与 ClinicBusinessCF「处方列表」弹窗内层色板一致（.cf-dialog-swiper-toolbar） */
.doctor-skill-dialog-body {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.doctor-skill-dialog-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.doctor-skill-chart-cell {
  padding: 12px 14px 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  min-height: 420px;
}

@media (min-width: 992px) {
  .doctor-skill-chart-cell {
    margin-bottom: 0;
  }
}

.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}
</style>

<!-- append-to-body 弹层：配色与 ClinicBusinessCF「处方列表」.clinic-cf-dialog 一致 -->
<style>
.el-dialog.clinic-doctor-skill-dialog {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #363944;
}

.el-dialog.clinic-doctor-skill-dialog .el-dialog__header {
  padding: 14px 20px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.08) 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.el-dialog.clinic-doctor-skill-dialog .el-dialog__title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.el-dialog.clinic-doctor-skill-dialog .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.7);
}

.el-dialog.clinic-doctor-skill-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: #68f5b9;
}

.el-dialog.clinic-doctor-skill-dialog .el-dialog__body {
  padding: 16px 20px 22px;
  background: #363944;
  color: #e8eaef;
}
</style>
